import { render } from "./Stocktakes.vue?vue&type=template&id=1f496a68"
import script from "./Stocktakes.vue?vue&type=script&lang=js"
export * from "./Stocktakes.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__